import React, { useState, useEffect } from "react";
import StreamResult from "../StreamResult";

const Component = ({ input, transInput, results, selectTreeButton, selectTreeButtonType, selectResultPage, compareItems, streamDescMap, streamNodeMap, elementDescMap, tempUnit, pressUnit }: any) => {
  console.log("results", results);
  return <StreamResult
      source={results}
      materials={transInput}
      selectTreeButton={selectTreeButton}
      selectTreeButtonType={selectTreeButtonType}
      input={input}
      selectResultPage={selectResultPage}
      compareItems={compareItems} // 传递对比数据
      streamDescMap={streamDescMap}
      streamNodeMap={streamNodeMap}
      elementDescMap={elementDescMap}
      tempUnit={tempUnit}
      pressUnit={pressUnit}
    />;
};

export default Component;
